<template>
  <section class="message-styling flex flex-col items-start justify-center gap-4 self-stretch p-3">
    <Switch v-model:value="messageSwitch" :label="t('common.messageStyling')" />
    <section v-if="messageSwitch" class="form_settings">
      <div class="grid grid-cols-2 gap-3">
        <ColorInput
          :label="t('common.background')"
          :compact="true"
          :color="formSubmitMessageStyle.bgColor"
          @update:color="handleThankYouMessageBackground"
        />
        <ColorInput
          :label="t('common.fontColor')"
          :compact="true"
          :color="formSubmitMessageStyle.color"
          @update:color="handleThankYouMessageColor"
        />
      </div>
      <FontFamilyInput
        :label="t('common.fontFamily')"
        :value="formSubmitMessageStyle.fontFamily"
        @update:value="handleThankYouFontFamily"
      />
      <div class="grid grid-cols-2 gap-3">
        <PixelNumber
          :label="t('common.size')"
          :value="formSubmitMessageStyle.fontSize"
          @update:value="handleLabelFontSize"
        />
        <div class="flex flex-col items-start gap-2 self-stretch">
          <UITextXsMedium>{{ t("common.weight") }}</UITextXsMedium>
          <UISelect
            id="font-weight-select"
            :value="formSubmitMessageStyle.fontWeight"
            :options="fontWeightOptions"
            size="large"
            @update:value="handleLabelFontWeight"
          />
        </div>
      </div>
    </section>
  </section>
</template>

<script setup lang="ts">
import { useAppStore } from "@/store/app";
import { UISelect, UITextXsMedium } from "@gohighlevel/ghl-ui";
import { computed, reactive } from "vue";
import { useI18n } from "vue-i18n";
import ColorInput from "../Elements/ColorInput.vue";
import FontFamilyInput from "../Elements/FontFamilyInput.vue";
import PixelNumber from "../Elements/PixelNumber.vue";
import Switch from "../Elements/Switch.vue";

const { t } = useI18n();
const store = useAppStore();

// Font weight options from 100 to 700
const fontWeightOptions = [
  { label: "100 - Thin", value: 100 },
  { label: "200 - Extra Light", value: 200 },
  { label: "300 - Light", value: 300 },
  { label: "400 - Normal", value: 400 },
  { label: "500 - Medium", value: 500 },
  { label: "600 - Semi Bold", value: 600 },
  { label: "700 - Bold", value: 700 },
];

// Use computed property for two-way binding with the store
const messageSwitch = computed({
  get: () => store.submitMessageStyle.isEnabled,
  set: (value) => {
    store.submitMessageStyle.isEnabled = value;
    store.anyUnsavedChanges = true;
  },
});

const formStoreSubmitMessageStyle = store.getFormSubmitMessageStyle;
const formSubmitMessageStyle = reactive(formStoreSubmitMessageStyle);

const handleThankYouMessageBackground = (val: string) => {
  store.submitMessageStyle.bgColor = val;
  store.anyUnsavedChanges = true;
};
const handleThankYouMessageColor = (val: string) => {
  store.submitMessageStyle.color = val;
  store.anyUnsavedChanges = true;
};
const handleThankYouFontFamily = (val: string) => {
  store.fontCollection.push(val);
  store.submitMessageStyle.fontFamily = val;
  store.anyUnsavedChanges = true;
};
const handleLabelFontSize = (val: string) => {
  store.submitMessageStyle.fontSize = parseFloat(val);
  store.anyUnsavedChanges = true;
};
const handleLabelFontWeight = (val: number) => {
  store.submitMessageStyle.fontWeight = val;
  store.anyUnsavedChanges = true;
  store.addToHistory();
};
</script>

<style>
.message-styling {
  border-radius: 12px;
  border: 1px solid #eaecf0;
  background: #ffffff;
}
</style>
